import React from 'react';
import {
  CTASection,
  Markdown,
  OurProcess,
  PageBanner,
  ScheduleMeetingBox,
} from '../shared/layout/components';
import { Container, Box, Grid, Typography, Paper } from '@mui/material';
import robotSD2 from '../assets/images/robot-problem-hover.png';
import craig from '../assets/images/clamb3.png';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { icons } from '../icons';
import { RobotFormBox } from './components';
import { useCodeReview } from '../api/services/codereview.query';
import { LoadingIndicator, Meta } from '../shared/components';
import { DynamicsFormComponent } from '../contact/components';

export const CodeReviewsPage: React.FC = () => {
  const codeReviewQuery = useCodeReview();
  if (!codeReviewQuery.data) return <LoadingIndicator />;
  return (
    <Box>
      <Meta seo={codeReviewQuery.data.codeReviewPage.data.attributes.MetaData} />
      <PageBanner
        headline={codeReviewQuery.data.codeReviewPage.data.attributes.Banner.Headline}
        subCopy={codeReviewQuery.data.codeReviewPage.data.attributes.Banner.Subhead}
      />
      <Container maxWidth="xl">
        <Grid container spacing={4}>
          <Grid item xs={12} lg={6} flexDirection="column">
            <Markdown children={codeReviewQuery.data.codeReviewPage.data.attributes.PageCopy} />
          </Grid>
          <Grid item xs={12} md={6}>
            <RobotFormBox image={robotSD2}>
              <Typography variant="h3">Free Consultation</Typography>
              <DynamicsFormComponent
                form={
                  codeReviewQuery.data.codeReviewPage.data.attributes.DynamicsForm.data.attributes
                }
              />
              <ScheduleMeetingBox
                image={craig}
                fname="Craig"
                lname="Lamb"
                title="Managing Partner"
                link="https://drift.me/craiglamb"
                linkcopy="View My Calendar"
              />
            </RobotFormBox>
          </Grid>
        </Grid>
      </Container>
      <Paper variant="gradient2">
        <Container>
          <OurProcess />
        </Container>
      </Paper>
      <CTASection
        title="We are ready to help you"
        linkCopy="Contact Us"
        link="/contact-us"
        img={icons.plane as IconProp}
      />
    </Box>
  );
};
